import { useEffect, useState } from "react";

const BOOT_LINES = [
  "INITIALIZING NEON CORE...",
  "MOUNTING VISUAL CORTEX...",
  "CALIBRATING BLOOM ARRAY...",
  "LOADING PROJECT HOLOGRAMS...",
  "SYNCING DATA STREAMS...",
  "SYSTEM READY.",
];

export default function LoadingScreen({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [lineIndex, setLineIndex] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((p) => {
        const next = Math.min(100, p + (2 + Math.random() * 6));
        return next;
      });
    }, 90);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const lineInterval = setInterval(() => {
      setLineIndex((i) => Math.min(BOOT_LINES.length - 1, i + 1));
    }, 420);
    return () => clearInterval(lineInterval);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      const t = setTimeout(() => {
        setLeaving(true);
        setTimeout(onComplete, 650);
      }, 300);
      return () => clearTimeout(t);
    }
  }, [progress, onComplete]);

  return (
    <div
      data-testid="loading-screen"
      className={`fixed inset-0 z-[100] flex flex-col justify-between bg-[#050505] px-6 md:px-16 py-10 transition-opacity duration-500 ${
        leaving ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      style={{
        transitionTimingFunction: "ease-out",
      }}
    >
      <div className="font-mono text-[10px] md:text-xs text-[#01FFFF] tracking-[0.3em]">
        ADLAN MS PORTOFOLIO — BOOT SEQUENCE
      </div>

      <div className="flex flex-col gap-6">
        <div className="font-mono text-xs md:text-sm text-[#8A9AAB] space-y-1 h-24 overflow-hidden">
          {BOOT_LINES.slice(0, lineIndex + 1).map((line, i) => (
            <div key={i} className={i === lineIndex ? "text-[#01FFFF]" : ""}>
              &gt; {line}
            </div>
          ))}
        </div>

        <div className="w-full">
          <div className="flex justify-between font-mono text-[10px] text-[#8A9AAB] mb-2 tracking-widest">
            <span>LOADING</span>
            <span data-testid="loading-progress-value">{Math.floor(progress)}%</span>
          </div>
          <div className="h-[3px] w-full bg-[#111116] overflow-hidden">
            <div
              className="h-full bg-[#01FFFF]"
              style={{
                width: `${progress}%`,
                boxShadow: "0 0 12px #01FFFF, 0 0 4px #01FFFF",
                transition: "width 90ms linear",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
